import React from 'react';
import cn from 'classnames';
import { bool, func, number, string, arrayOf, shape } from 'prop-types';
import i18next from 'i18next';

import { DATA_TEST_ID } from '~constants/tests';
import { addressPropTypes } from '~propTypes/address';
import SectionTitle from '~components/SectionTitle';
import { ICON_ADDRESS } from '~screens/Commerce/components/ChangeAddress/constants';
import Address from '~screens/Commerce/components/ChangeAddress/components/Address';
import { arrayHasLength } from '~utils/array';
import UserAddresses from '~screens/Commerce/components/ChangeAddress/components/UserAddresses/index';

import Results from './layout';
import styles from './styles.module.scss';

function ResultsContainer({
  onResultSelect,
  maxResults,
  loading,
  isOpen,
  results,
  onMouseOver,
  onMouseOut,
  lastAddresses,
  selectedAddress,
  onAddressSelect,
  onlySearch = false
}) {
  return (
    <div
      className={cn('full-width', styles.results, { [styles.active]: isOpen })}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      data-testid={DATA_TEST_ID.searchAddressResults}>
      <Results onResultSelect={onResultSelect} maxResults={maxResults} results={results} loading={loading} />
      {!onlySearch && (
        <>
          <UserAddresses onAddressSelect={onAddressSelect} selectedAddress={selectedAddress} />
          {arrayHasLength(lastAddresses) && (
            <>
              <SectionTitle
                titleClassName={`text-base ${styles.titleLastAddresses}`}
                className={`${styles.subtitleForm} m-bottom-2 m-top-2`}
                noSeparator
                tag="h4">
                {i18next.t('DeliveryOrPickup:lastAddresses')}
              </SectionTitle>
              {lastAddresses.map((address) => (
                <Address
                  key={address.placeId}
                  className={styles.lastAddress}
                  data={address}
                  icon={ICON_ADDRESS[address?.kind] || null}
                  onClick={onAddressSelect}
                  selectedAddressId={selectedAddress?.id || selectedAddress?.placeId || null}
                />
              ))}
            </>
          )}
        </>
      )}
    </div>
  );
}

ResultsContainer.propTypes = {
  results: arrayOf(
    shape({
      placeId: string
    })
  ).isRequired,
  onAddressSelect: func.isRequired,
  onMouseOut: func.isRequired,
  onMouseOver: func.isRequired,
  onResultSelect: func.isRequired,
  isOpen: bool,
  lastAddresses: arrayOf(addressPropTypes),
  loading: bool,
  maxResults: number,
  onlySearch: bool,
  selectedAddress: addressPropTypes
};

export default ResultsContainer;
